/**
 * @param {boolean} deleteYes refers to the final state that we want to set the Deleted field to
 * when soft deleting a record. True if setting Deleted flag to Y, False if setting to N
 * TODO: There is a similar param in form-model-utils.ts called isDeletedPost. I think they can
 * be merged. Which one makes more sense? You decide!
 */
export class DeleteHelper {
	private static failureMessage(deleteYes: boolean): string {
		let message: string;
		if (deleteYes) {
			message = 'delete-record-notification.delete-error-message';
		} else {
			message = 'delete-record-notification.un-delete-error-message';
		}
		return message;
	}

	private static successMessage(deleteYes: boolean): string {
		let message: string;
		if (deleteYes) {
			message = 'delete-record-notification.delete-success-message';
		} else {
			message = 'delete-record-notification.un-delete-success-message';
		}
		return message;
	}

	public static resultMessages(deleteYes: boolean): any {
		const messages = {
			success: DeleteHelper.successMessage(deleteYes),
			error: DeleteHelper.failureMessage(deleteYes),
		};
		return messages;
	}

	public static confirmMessage(deleteYes: boolean): string {
		return deleteYes
			? 'delete-record-modal.confirm-delete-ask'
			: 'delete-record-modal.confirm-undelete-ask';
	}
}
